import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CardFace, { ICardFaceDetails } from 'components/CardFace';

import './PlayerCardWithFade.scss';

export enum PlayerCardWithFadeWidths {
  fiftyEight = '58px',
  oneHundredAndFifty = '150px'
}
export interface IPlayerCardWithFade {
  name?: string;
  teamCode?: string;
  revealed?: boolean;
  startAnimation?: boolean;
  selectionNumber?: string;
  showCta?: boolean;
  width: PlayerCardWithFadeWidths;
  details?: ICardFaceDetails;
  onRevealAnimationEndCallBack?: () => void;
}

const PlayerCardWithFade = (props: IPlayerCardWithFade) => {
  const { t } = useTranslation();
  const topRef = useRef<HTMLDivElement>(null);
  const [animateReveal, setAnimateReveal] = useState<boolean>(false);

  useEffect(() => {
    if (props.startAnimation) setAnimateReveal(true);
  }, [props.startAnimation]);

  useEffect(() => {
    const node = topRef.current;
    if (!node) {
      return;
    }

    const callback = props.onRevealAnimationEndCallBack ? props.onRevealAnimationEndCallBack : () => null;

    node.addEventListener('transitionend', callback);
    return () => node.removeEventListener('transitionend', callback);
    // eslint-disable-next-line
  }, [props.onRevealAnimationEndCallBack]);

  const getFontConfig = () => {
    switch (props.width) {
      case PlayerCardWithFadeWidths.fiftyEight:
        return {
          maxFontSize: 9,
          minFontSize: 6
        };
      case PlayerCardWithFadeWidths.oneHundredAndFifty:
        return {
          maxFontSize: 30,
          minFontSize: 21
        };
      default:
        return {
          maxFontSize: 9,
          minFontSize: 6
        };
    }
  };

  const cardFaceConfig = {
    playerName: props.name,
    teamCode: props.teamCode?.toLowerCase(),
    multiLine: true,
    details: props.details,
    ...getFontConfig()
  };

  return (
    <div className={`player-card-with-cross-fade player-card-with-cross-fade--width-${props.width} ${animateReveal ? 'player-card-with-cross-fade--animate' : ''}`}>
      <div className="player-card-with-cross-fade__bottom">
        <CardFace {...cardFaceConfig} />
      </div>

      {!props.revealed && (
        <div className="player-card-with-cross-fade__top" ref={topRef} onClick={() => setAnimateReveal(true)} style={{ display: props.revealed ? 'none' : 'block' }}>
          <CardFace />
          {props.showCta && <button className="player-card-with-cross-fade__cta">{t('reveal')}</button>}
        </div>
      )}
    </div>
  );
};

export default PlayerCardWithFade;
